import { render, staticRenderFns } from "./GradesAdd.vue?vue&type=template&id=0586daba&scoped=true"
import script from "./GradesAdd.vue?vue&type=script&lang=js"
export * from "./GradesAdd.vue?vue&type=script&lang=js"
import style0 from "./GradesAdd.vue?vue&type=style&index=0&id=0586daba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0586daba",
  null
  
)

export default component.exports